module.exports = __webpack_public_path__ + "static/media/acosta_ziegler.9001bb37.jpg";